export default {
  title: 'Nebula buds AI-opkald', // "Nebula buds AI通话" 翻译为丹麦语
  userID: 'Bruger-ID : ', // "用户ID : "
  hurryUp: 'Vent på opkald fra den anden part', // "等待对方呼叫"
  waitingCall: 'Vent på opkald fra den anden part på denne side, luk ikke siden for tidligt.', // "在此页面等待对方拨打电话，请勿提前关闭。"
  subSwitch: 'Undertekstswitch', // "字幕开关"
  initWait: 'Vent på initialisering', // "等待初始化"
  initSuccess: 'Initialisering afsluttet, vent på opkald fra den anden part. Luk ikke siden!', // "初始化完成，等待对方呼叫。请勿关闭页面！"
  callStart: 'Opkaldet er forbundet', // "电话接通"
  callEnd: 'Opkaldet er afsluttet', // "通话结束"
  careful: 'Advarsel : ', // "注意 : "
  wait: 'Opkaldskomponenten er klar, vent på opkald fra den anden part', // "通话组件已准备好,等待对方拨打电话"
  langSwitch: {
    ar: 'Arabisk', // "阿拉伯语"
    da: 'Dansk', // "丹麦语"
    de: 'Tysk', // "德语"
    en: 'Engelsk', // "英语"
    es: 'Spansk', // "西班牙语"
    fil: 'Filippinsk', // "菲律宾语"
    fr: 'Fransk', // "法语"
    hi: 'Hindi', // "印地语"
    id: 'Indonesisk', // "印度尼西亚语"
    it: 'Italiensk', // "意大利语"
    ja: 'Japansk', // "日文"
    ko: 'Koreansk', // "韩语"
    ms: 'Malaysisk', // "马来语"
    no: 'Norsk', // "挪威语"
    pt: 'Portugisisk', // "葡萄牙语"
    ru: 'Russisk', // "俄语"
    sv: 'Svensk', // "瑞典语"
    th: 'Thailandsk', // "泰语"
    tr: 'Tyrkisk', // "土耳其语"
    vi: 'Vietnamesisk', // "越南语"
    zh: 'Kinesisk' // "中文"
  }
}
